import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import InteractionFilledSvg from "@ant-design/icons-svg/es/asn/InteractionFilled";
import AntdIcon from "../components/AntdIcon";
var InteractionFilled = function InteractionFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: InteractionFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  InteractionFilled.displayName = 'InteractionFilled';
}
export default /*#__PURE__*/React.forwardRef(InteractionFilled);